import React from "react";
import styled from "styled-components";
import { colors } from "utils";
import { Card, CardTitle } from "./styles";

const TITLE_ID = "teacher-reports-metrics-definitions-title";

const Terms = styled.dl`
  column-gap: 16px;
  display: grid;
  font-size: 13px;
  grid-template-columns: max-content 1fr;
  margin: 10px 0 0;
  row-gap: 6px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    row-gap: 2px;
  }
`;

const Term = styled.dt`
  color: ${colors.nightlyWoods950};
  font-weight: 600;
`;

const Definition = styled.dd`
  color: ${colors.milkGlass950};
  margin: 0;
`;

const DEFINITIONS = [
  {
    term: "User Wait",
    definition:
      "Time from the end of the session until its first report was ready for the teacher. Regenerating the report later does not change it."
  },
  {
    term: "Report Generation",
    definition:
      "Time one report took to generate, from the moment it was requested until it was ready. The table shows the session's most recent report. If an earlier attempt failed and left no report, its time can be included."
  },
  {
    term: "Report Count",
    definition:
      "Number of reports generated for the session that a teacher could open: the first one and every regeneration. Failed attempts are not counted."
  },
  { term: "Measurement", definition: "What the figures and the chart measure: User Wait or Report Generation." },
  {
    term: "Report Count: All / First",
    definition:
      "With Report Generation, All measures every report of each session and First only the first one. User Wait is always measured once per session."
  },
  { term: "Typical", definition: "The median: half of the measurements are shorter." },
  { term: "p90, p95, p99", definition: "90%, 95% and 99% of the measurements are at or below this value." },
  { term: "Late", definition: "The first report was ready more than 10 minutes after the session ended." },
  { term: "Stuck", definition: "The report has been processing for 10 minutes or more." },
  {
    term: "Needs Attention",
    definition:
      "Sessions that never had a report and whose generation failed or is stuck, plus sessions whose report was late."
  },
  { term: "Completed", definition: "The teacher has a report now." },
  { term: "Processing", definition: "A report is being generated." },
  {
    term: "Failed",
    definition:
      "The teacher has no report: the generation failed, produced nothing the teacher can open, or was never requested."
  },
  {
    term: "Not started",
    definition: "The session ended without starting. It has no report and is left out of the figures."
  }
];

export const Definitions = () => (
  <Card aria-labelledby={TITLE_ID}>
    <CardTitle id={TITLE_ID}>Definitions</CardTitle>
    <Terms>
      {DEFINITIONS.map(({ term, definition }) => (
        <React.Fragment key={term}>
          <Term>{term}</Term>
          <Definition>{definition}</Definition>
        </React.Fragment>
      ))}
    </Terms>
  </Card>
);
